import { makeStyles } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";

const styles = makeStyles((theme) => ({
  notificationUnread: {
    backgroundColor: theme.palette.secondary.main,
  },
  notificationRead: {
    backgroundColor: "inherit",
  },
  notificationIconUnread: {
    color: theme.palette.error.main,
    fontSize: 12,
    marginTop: theme.spacing(0.5),
  },
  notificationIconRead: {
    color: grey[500],
    fontSize: 12,
    marginTop: theme.spacing(0.5),
  },
  notificationTitle: {
    fontSize: "14px",
    fontWeight: 500,
  },
  notificationTitleWarning: {
    color: theme.palette.warning.main,
  },
  notificationTitleError: {
    color: theme.palette.error.main,
  },
  titleIcon: {
    verticalAlign: "middle",
    display: "inline-block",
    width: 16,
    height: 16,
    marginRight: theme.spacing(0.5),
  },
  notificationText: {
    marginTop: theme.spacing(0.5),
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "170%",
  },
  notificationDate: {
    color: grey[600],
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "1.5",
  },
  truncatedContent: {
    display: "-webkit-box",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    WebkitLineClamp: 3,
    lineHeight: "1.5em",
    maxHeight: "4.5em",
    WebkitBoxOrient: "vertical",
    wordBreak: "break-word",
    overflowWrap: "break-word",
  },

  notificationButton: {
    color: theme.palette.primary.main,
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "1.5",
    textTransform: "uppercase",
  },
  attachmentInfo: {
    fontSize: "14px !important",
  },
  fileIcon: {
    verticalAlign: "middle",
    display: "inline-block",
    transform: "rotate(90deg)",
    width: 16,
    height: 16,
    color: grey["500"],
    marginRight: theme.spacing(0.5),
  },
  contentItem: {
    paddingTop: 0,
    paddingBottom: theme.spacing(0.5),
    "&:last-child": {
      paddingBottom: 0,
    },
  },
}));
export default styles;
